<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Rejected Incident's</strong>
                        <div class="card-header-actions">
                            <router-link to="/incident_master">
                                <b-button variant="info" size="sm" style="color: #fff;"><i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                                    Back To Incident Master</b-button>
                            </router-link>
                        </div>
                    </div>

                    <div>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group label-cols-sm="3" label="Search:">
                                <b-input-group>
                                    <b-form-input v-model="filter" placeholder="Enter Vehicle number / Hub Name" @input="searchdata"></b-form-input>
                                    <b-input-group-append>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label-cols-sm="6" label="Select Incident Level:">
                                    <b-form-checkbox-group 
                                    v-model="selectedLevels" 
                                    class="mt-1" 
                                    @input="searchdata">
                                    
                                    <b-form-checkbox 
                                      value="hub" 
                                      switch 
                                      class="custom-checkbox mb-1">
                                      Hub Level
                                    </b-form-checkbox>
                                    
                                    <b-form-checkbox 
                                      value="vehicle" 
                                      switch 
                                      class="custom-checkbox">
                                      Vehicle Level
                                    </b-form-checkbox>
                                  </b-form-checkbox-group>
                                    <!-- <span @click="changescheck()">
                                        <b-form-radio v-model="selectedLevels" value="hub" @input.native="searchdatalevels($event, 'hub')" name="some-radios">
                                            Hub Level
                                        </b-form-radio>
                                    </span>
                                  <b-form-radio v-model="selectedLevels1" value="vehicle" @input.native="searchdatalevels($event, 'vehicle')" name="some-radios1">
                                    Vehicle Level
                                  </b-form-radio> -->
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group label-cols-sm="4" label="Select Origin:">
                                <ejs-multiselect 
                                    id='multi_select2' 
                                    placeholder="Origin Listing" 
                                    v-model="valueWH" 
                                    :dataSource='optionsWH' 
                                    :showSelectAll='showSelectAll' 
                                    selectAllText="Select All" 
                                    unSelectAllText="Unselect All" 
                                    :fields='fieldWH' 
                                    :allowCustomValue='allowCustomValue' 
                                    enableGroupCheckBox="true" 
                                    mode="CheckBox" 
                                    @change="searchdata"
                                />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col>
                            <div class="text-right">
                               <h6><b>Total Records : <span style="color: red;">{{ totalRows }}</span></b></h6>
                            </div>
                        </b-col>
                    </b-row>

                    <div>
                        <b-table show-empty responsive :fields="fields" :items="rejectlist" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                              </div>
                              <template slot="ttr" slot-scope="row">
                                <div>
                                    {{ ((row.item.ttr?row.item.ttr.hours:'00' )|| '00').toString().padStart(2, '0') }}:
                                    {{ ((row.item.ttr?row.item.ttr.minutes:'00') || '00').toString().padStart(2, '0') }}                                                                     
                                  </div>
                              </template>
                              <template slot="vehicle_no" slot-scope="row">
                                <div>
                                    {{ row.item.hubvehicle }}
                                </div>
                                </template>
                                <template slot="incident_level" slot-scope="row">
                                <div>
                                    {{ row.item.incidentlevel }}
                                </div>
                                </template>
                                <template slot="incident_type" slot-scope="row">
                                <div>
                                    {{ row.item.incidenttype }}
                                </div>
                            </template>
                              <template slot="Action" slot-scope="row">
                                <b-button
                                  size="sm"
                                  data-toggle="tooltip"
                                  title="View Rejected Incident"
                                  @click="viewopenincident(row.item)"
                                  :modalShow= modalShow
                                >View Button</b-button>
                            </template>
                        </b-table>
                    </div>

                    <b-modal title="View Rejected Incident" v-model="modalShow" size="xl" hide-footer>
                        <template slot="default" slot-scope="{ hide }">
                            <b-row class="p-3">
                                <b-col sm="3">
                                    <span><b>Incident Level : -</b> <span v-if="rejectincident && rejectincident.incidentlevel"> {{rejectincident.incidentlevel}} level</span></span>
                                </b-col>
                                <b-col sm="3">
                                    <span><b>Incident Type : -</b> {{rejectincident.incidenttype}}</span>
                                </b-col>
                                <b-col sm="4">
                                    <div v-if="!isEditing" class="d-flex">
                                        <p><b>Time to Resolve : </b>{{ formattedTime }}</p> &nbsp;&nbsp;&nbsp;
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="p-3">
                                <b-col md="6">
                                    <div>
                                        <span v-if="rejectincident.incidentlevel === 'vehicle'"><b>Vehicle No. : -</b> {{rejectincident.hubvehicle}}</span>
                                        <span v-if="rejectincident.incidentlevel === 'hub'"><b>Hub Name. : -</b> {{rejectincident.hubvehicle}}</span>
                                        <br><br>
                                        <span><b>Incident name : -</b> {{rejectincident.incident_name}}</span>
                                        <br><br>
                                        <span><b>Incident ID : -</b> {{rejectincident.incident_id}}</span>
                                        <br><br>
                                        <span><b>Incident time : -</b> {{rejectincident.createddate | ConvertTime12hour()}}</span>
                                        <br><br>
                                        <span><b>Incident status : -</b> {{rejectincident.report_status}}</span>
                                    </div>
                                    <div class="mt-5">
                                        <h5>Incident images :- </h5>
                                        <div>
                                            <img :src="rejectincident.report_image" alt="images" width="70%" height="200px">
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="text-center">
                                        <h5>LOAD STATUS</h5>
                                    </div>
                                    <b-table show-empty :fields="open_indifields" :items="loaditems" :busy="isBusymodel" responsive>
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                          </div>
                                    </b-table>

                                    <div>
                                        <h5>Incident Video :- </h5>
                                        <!-- <video :key="video"  width="450"  controls>
                                            <source
                                                :src="video"
                                                type="video/mp4"
                                            >
                                        </video> -->
                                        <!-- {{ rejectincident }} -->
                                        <b-embed  type="video" controls>
                                            <source :src="rejectincident.report_video">
                                          </b-embed>

                                    </div>
                                </b-col>

                                <b-col md="6">
                                    <br><br>
                                    <b-form-group label-cols="2" label="Comment : ">
                                        <b-form-textarea id="textarea" v-model="rejectincident.reject_reason" rows="4" disabled></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <hr>
                            <br>
                            <footer class="float-right"> 
                                <b-button size="md" variant="danger" @click="cancel()"
                                    >cancel</b-button
                                    >
                            </footer>
                        </template>
                        <template slot="modal-footer" slot-scope="{ hide }">
                            <b-button size="sm" style="display:none">
                                  Cancel
                            </b-button>
                        </template>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>


<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    data() {
        return {
            filter: null,
            fields: [
                { key: "report_id",  label: "SNO. "},
                { key: "vehicle_no",  label: "Vehicle Number/Hub Name"},
                { key: "incident_id",  label: "Incident Code"},
                { key: "incident_level",  label: "Incident Level"},
                { key: "incident_type",  label: "Incident Type"},
                { key: "incident_name",  label: "Incident Name"},
                { key: "report_status",  label: "Incident Status"},
                { key: "total_count",  label: "No Of Loads"},
                { key: "ttr",  label: "Time To Resolve"},
                { key: "Action",  label: "Action"},
            ],
            rejectlist :[],
            totalRows :0,
            isBusy :false,
            modalShow :false,
            rejectincident : {}, 
            open_indifields :[ 
                {key : 'total_count', label :'Total Count'},
                {key : 'ofd_count', label :'OFD Count'},
                {key : 'intransit_count', label :'Intransit Count'},
                // {key : 'rto_count', label :'RTO Count'},
                // {key : 'ndr_count', label :'NDR Count'},
            ],
            loaditems: [],
            loadtotalRows :0,
            isBusymodel : false,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],

            selectedLevels:null,
            selected_Levels:null,
            isEditing: false, 
            timeInput:''
        }
    },

    created() {
        var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
        this.showWHlist()
        this.RejectreportList();
    },
    computed: {
        formattedTime() {
        const hours = ((this.rejectincident.ttr?this.rejectincident.ttr.hours:'0') || '00').toString().padStart(2, '0');
        const minutes = ((this.rejectincident.ttr?this.rejectincident.ttr.minutes:'0') || '00').toString().padStart(2, '0');

        return `${hours}:${minutes}`;
        }

    },
    methods: {


        clearFilter(){
            this.filter=null;
            this.OpenreportList();
        },
        showWHlist:function(){
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          
          var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
              .then(result => {
              
              if (result.body.returnmsg === 'Successful') {
                  this.optionsWH=[];
              
                  this.WHData  = result.body.returnvalue;
                  
                  for(let j = 0; j < this.WHData.length; j++) {
                      let WH = {
                      name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                      id: this.WHData[j].hubid,
                      }
                  this.optionsWH.push(WH);
                  }
              
              } else {              
                  this.WHData  = result.body.returnvalue;
              }
          

          })
          .catch(ex => {
              console.log("error-----", ex);
          });
        },
       
        viewopenincident :function (value){
            this.modalShow = true;
            this.rejectincident = value;
            this.timeInput = `${((this.rejectincident.ttr?this.rejectincident.ttr.hours:'0') || '00').toString().padStart(2, '0')}:${((this.rejectincident.ttr?this.rejectincident.ttr.minutes:'00') || '00').toString().padStart(2, '0')}`;
            this.VehicleloadList(value.report_id);
        },

        cancel : function () {
            this.modalShow = false;
        },

        searchdata(selected) {
             if (selected.length) {
                if (selected.includes('hub') && selected.includes('vehicle')) {
                    this.selected_Levels=null;
                } else if (selected.includes('hub')) {
                    this.selected_Levels='hub';
                } else if (selected.includes('vehicle')) {
                    this.selected_Levels='vehicle';
                }
             }
             else{
                this.selected_Levels=null;
             }
            this.RejectreportList();
        },

        RejectreportList : function () {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.rejectlist = [];
            this.totalRows = 0;

            var filter = []
            if (this.filter) {
            
                filter.push(this.filter)
            }
            this.isBusy = true;
            const obj = {
                incidentlevel: this.selected_Levels,
                hubid:this.valueWH,
                searchparams:filter,
                report_status :"Rejected"
            }

            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/incidentReportList`,obj)
            .then(result =>{
                console.log("result",result)
                this.isBusy = false;
                if (result.body.returnmsg === "Successful") {
                    this.rejectlist = result.body.returnvalue;

                    this.totalRows = result.body.returnvalue.length;
                } else {
                    this.rejectlist = [];
                    this.totalRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        VehicleloadList : function (report_id) {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.loaditems = [];
                    this.loadtotalRows = 0;
            this.isBusymodel = true;
            const obj = {
                vehicle_id : this.rejectincident.vehicle_id== null ? '0' : this.rejectincident.vehicle_id,
                report_status :"Rejected",
                report_id : report_id,
            }
            console.log("obj",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleLoadCount`,obj)
            .then(result =>{
                this.isBusymodel = false;
                if (result.body.returnmsg === "Successful") {
                    this.loaditems = result.body.returnvalue;
                    this.loadtotalRows = result.body.returnvalue.length;
                } else {
                    this.loaditems = [];
                    this.loadtotalRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
    },
}
</script>